var Cookies;
(function (Cookies) {
    myonce('setCookies', () => {
        const $cookie = document.querySelector('.cookies');
        const $privacyModal = document.querySelector('.privacy-modal');
        if ($cookie && $privacyModal) {
            const id = $cookie.getAttribute('data-id-cookie');
            let $accept = $cookie.querySelector('.btn');
            const $openBtns = document.querySelectorAll('[data-policy-modal="open"], a[href="#cookie-modal"]');
            const isDesktop = window.innerWidth >= 992;
            const $tabs = $privacyModal.querySelectorAll('.privacy-item');
            const $tabsContent = $privacyModal.querySelectorAll('.info-head');
            const $accordionLink = $privacyModal.querySelectorAll('.accordion-title');
            const $switchBtn = $privacyModal.querySelector('.switch-btn');
            const $switchInput = $switchBtn === null || $switchBtn === void 0 ? void 0 : $switchBtn.querySelector('input');
            const $switchMobileContainer = $privacyModal.querySelector('.switch-mobile-container');
            const $confirmBtn = $privacyModal.querySelector('.modal-footer .btn');
            const $mask = $privacyModal.querySelector('.mask');
            function save(analytics) {
                if (id) {
                    localforage
                        .getItem('set-cookies')
                        .then(cookies => {
                        cookies = cookies || {};
                        cookies[id] = {
                            analitycs: !!analytics,
                        };
                        localforage.setItem('set-cookies', cookies);
                    })
                        .finally(() => {
                        $cookie.remove();
                        $privacyModal.classList.remove('open');
                        if (analytics) {
                            handleTrackers();
                        }
                        else {
                            clearAllCookies();
                        }
                    });
                }
            }
            function init() {
                localforage.getItem('set-cookies').then(cookies => {
                    cookies = cookies || {};
                    if (id in cookies) {
                        $cookie.remove();
                    }
                    else {
                        $cookie.classList.add('animation-cookies');
                        $accept.addEventListener('click', () => {
                            save(true);
                        });
                    }
                });
                localforage.setItem('latest-cookie-policy', id);
                initModal();
            }
            function initModal() {
                if (isDesktop) {
                    $tabs.forEach(element => {
                        element.addEventListener('click', () => {
                            clearTabs();
                            element.classList.add('active');
                            const activeItem = element.getAttribute('data-tab');
                            showActiveContent(activeItem);
                        });
                    });
                }
                else {
                    $tabsContent.forEach(element => {
                        const $wrapper = element.closest('.privacy-info-item');
                        element.addEventListener('click', () => {
                            if ($wrapper.classList.contains('active')) {
                                $wrapper.classList.remove('active');
                            }
                            else {
                                clearTabs();
                                $wrapper.classList.add('active');
                            }
                        });
                    });
                    $switchMobileContainer.appendChild($switchBtn);
                }
                $accordionLink.forEach(element => {
                    const $parent = element.closest('.accordion-link');
                    element.addEventListener('click', () => {
                        $parent.classList.toggle('open');
                    });
                });
                $openBtns.forEach(($openBtn) => {
                    $openBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        clearTabs();
                        $tabs[0].classList.add('active');
                        showActiveContent(1);
                        showModal();
                    });
                });
                $confirmBtn.addEventListener('click', () => {
                    save($switchInput.checked);
                    $privacyModal.classList.remove('open');
                });
                localforage.getItem('set-cookies').then(cookies => {
                    cookies = cookies || {};
                    if (id in cookies) {
                        $switchInput.checked = cookies[id].analytics;
                    }
                });
                $mask.addEventListener('click', () => {
                    save($switchInput.checked);
                });
            }
            function clearTabs() {
                if (isDesktop) {
                    $tabs.forEach(element => {
                        element.classList.remove('active');
                    });
                }
                else {
                    $tabsContent.forEach(element => {
                        const $wrapper = element.closest('.privacy-info-item');
                        $wrapper.classList.remove('active');
                    });
                }
            }
            function showActiveContent(activeItem) {
                $tabsContent.forEach(element => {
                    const $wrapper = element.closest('.privacy-info-item');
                    $wrapper.classList.remove('active');
                    const tabNumber = $wrapper.getAttribute('data-tab');
                    if (tabNumber == activeItem) {
                        $wrapper.classList.add('active');
                    }
                });
            }
            function showModal() {
                $cookie.remove();
                $privacyModal.classList.add('open');
            }
            function clearAllCookies() {
                document.cookie.split(";").forEach(function (c) {
                    document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                });
            }
            init();
        }
    });
})(Cookies || (Cookies = {}));
